import StatusLabel from 'Components/Atoms/Label/StatusLabel/StatusLabel';
import styles from './StatusList.module.sass';

const StatusList = ({
    list
}: Props) => {
    return <div className={styles['statuslist']}>
        {
            list?.map((i: any) =>
                <div className={styles['statuslist__item']}>
                    {
                        !i?.status_substatus
                        ? <><StatusLabel
                            status={i?.status}
                            label={i?.substatus}
                        /> { i?.total }</>
                        : <>
                            <StatusLabel status={i?.status}>
                                { i?.status_substatus }
                            </StatusLabel> { i?.total }
                        </>
                    }
                </div>
            )
        }
    </div>;
}

interface Props {
    list: any
}

export default StatusList;